export { default } from './TiraRanking';
